@import '../../../style/globals.scss';

.Badge {
    display: inline-flex;
    align-items: center;
    height: 21px;
    padding: 0px 8px;
    font-size: $font-size-p;
    font-weight: 500;
    border-radius: 5px;

    // Default is common
    color: var(--token-arise-theme-1-rarity-rarity-common-light);
    background-color: var(--token-arise-theme-1-rarity-rarity-common-mid);

    @each $rarity in $rarities {
        &.#{$rarity} {
            color: var(--token-arise-theme-1-rarity-rarity-#{$rarity}-light);
            background-color: var(--token-arise-theme-1-rarity-rarity-#{$rarity}-mid);
        }
    }

    p {
        display: inline-block;
        text-transform: capitalize;
    }
}
